/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Actions for Settings component
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */

import { createAction } from '../../modules/app/createAction';
import { TSettingsLoadersStopAction, TSettingsLoaderStartAction } from './PageSettingsTypes';
import { SETTINGS_LOADER_START, SETTINGS_LOADER_STOP } from './settingsConstants';


export const settingsLoaderStartAction = (): TSettingsLoaderStartAction =>
    createAction(SETTINGS_LOADER_START);
export const settingsLoaderStopAction = (): TSettingsLoadersStopAction =>
    createAction(SETTINGS_LOADER_STOP);
